import(/* webpackMode: "eager" */ "/home/circleci/project/snubes-web/src/app/error.tsx")